export default {
  authUser: undefined,
  loadingSession: true,
};
